/**
 * Lib.Common: Miscellaneous component declarations
 */


import ibInfobox            from './ib-infobox.vue';
import ibBadge              from './ib-badge.vue';
import ibMarquee            from './ib-marquee.vue';
import ibPaginate           from './ib-paginate.vue';
import ibTag                from './ib-tag.vue';
import ibVisibility         from './ib-visibility.vue';


export default [
    ibInfobox,
    ibBadge,
    ibMarquee,
    ibPaginate,
    ibTag,
    ibVisibility
];
